import React from 'react'
import { cn } from '../../utils/cn'

const sizeMap: Record<string, string> = {
  xs: 'h-3 w-3 border',
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-[3px]',
  xl: 'h-12 w-12 border-4',
}

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: keyof typeof sizeMap
  label?: string
}

/**
 * Indeterminate loading spinner. Inherits `currentColor` for the active arc, so
 * set color via `text-*` on the element or a parent.
 */
export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ size = 'md', label = 'Loading', className, ...props }, ref) => (
    <div
      ref={ref}
      role="status"
      aria-label={label}
      className={cn(
        'inline-block animate-spin rounded-full border-current border-r-transparent align-[-0.125em] text-content-muted',
        sizeMap[size],
        className,
      )}
      {...props}
    />
  ),
)
Spinner.displayName = 'Spinner'

export default Spinner
